import { Action, Dispatch } from 'redux'
import { SpecialHolidayType } from 'types/calendar'
import { db } from 'firebase/index'
import { fetchSpecialHolidaysAction } from 'reducks/calendar/actions'

const fetchSpecialHolidays = () => {
  return async (dispatch: Dispatch<Action>) => {
    const specialHolidays: SpecialHolidayType[] = []

    await db
      .collection('calendars')
      .get()
      .then((snapshots) => {
        snapshots.forEach((snapshot) => {
          const data = snapshot.data()
          if (!('date' in data)) return
          if (!('description' in data)) return
          if (!('is_holiday' in data)) return
          specialHolidays.push(data as SpecialHolidayType)
        })
      })

    dispatch(fetchSpecialHolidaysAction(specialHolidays))
  }
}

export default fetchSpecialHolidays
